import { Drawer, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { externalLink, homeUrl } from '@/utils/env';
import { PayDialogUserInfo } from '@/components/pay_ui/pay_dialog';
import i18n from '@/locales/init';
import { LoadingIcon } from '../LoadingIcon';
import { PayButton } from '../PayButtons';
import { PaySuccess, PaySuccessProps } from '../PaySuccess';

interface PayDrawerProps{
  open:boolean;
  setOpen: (open:boolean)=>void;
  handleClose:()=>void;
  amount:number | string;
  desc:string;
  userInfo:{
    avatar: string;
    userName: string;
    description: string;
  };
  modalContent: React.ReactNode;
  content: React.ReactNode;
  currentOrderStatus: number;
  orderNumber: string;
  successProps: PaySuccessProps;
  refreshOrder?: () => void;
}

let modal: any = null;
export const PayDrawer = (props:PayDrawerProps)=>{
  const { open, setOpen, handleClose, amount, userInfo, modalContent, desc, content, currentOrderStatus, orderNumber, successProps, refreshOrder } = props;
  const [openQrCode, setOpenQrCode] = useState(false);
  useEffect(() => {
    switch (currentOrderStatus) {
      case 1: break;
      case 2:
        // 支付中
        break;
      case 3:
        // 支付成功
        modal?.destroy();
        modal = null;
        break;
      case 4:
        // 支付失败
        break;
      default: break;
    }
    modal?.update({content: modalContent});
  }, [currentOrderStatus, orderNumber, modalContent]);


  const handleUseQrCode = ()=>{
    refreshOrder?.();
    setOpenQrCode(true);
    modal = Modal.confirm({
      icon: null,
      centered: true,
      width: 300,
      title: <div className='text-center relative'>{desc}
        <CloseOutlined className='absolute top-[0px] right-[-10px] cursor-pointer' onClick={()=>{
          modal?.destroy();
        }} /></div>,
      cancelButtonProps: {style: {display: 'none'}},
      footer: null,
      content: modalContent
    });
  };
  return <Drawer open={open} onClose={handleClose} height={'auto'} placement='bottom'
    styles={{
      header: {display: 'none'},
      body: {backgroundColor: '#000437', padding: 0, borderTopLeftRadius: 16, borderTopRightRadius: 16},
      content: {backgroundColor: 'transparent'},
      wrapper: {boxShadow: 'none'}
    }}>
    <div className='px-[16px] py-[10px] flex justify-between items-center'>
      <PayDialogUserInfo userInfo={userInfo} />
      <div className='text-white  flex items-center'>
        <span onClick={()=>{
          window.open(`${homeUrl}price.html`);
        }} className='mr-[10px] cursor-pointer text-[14px]'>{i18n.t('了解更多权益')}</span>
        <CloseOutlined className='text-[16px]' onClick={()=>{
          setOpen(false);
          setTimeout(()=>{
            handleClose();
          }, 300);
        }} />
      </div>
    </div>
    {
      currentOrderStatus === 3  && <div className='rounded-t-[16px] p-[20px] bg-white relative'><PaySuccess {...successProps} /></div>
    }
    {
      currentOrderStatus !== 3 && <div className='rounded-t-[16px] bg-white relative'>
        <div className='relative p-[16px]'>
          {content}
          {
            currentOrderStatus === 2 && <div className='absolute z-[1] w-full h-full left-0 top-0 bg-[#FFFFFF03] backdrop-blur-lg text-[#00000099]
            flex justify-center items-center text-[14px] rounded-[12px] flex-col'><LoadingIcon className='w-[20px] h-[20px] mb-[10px]' />{i18n.t('支付中...')}</div>
          }
        </div>

        <div className='p-[16px] border border-t-[#E5E5E5] relative height-[132px]'>
          <div className='absolute left-[10px] top-[-25px]'>{i18n.t('没有安装App？你还可以')}<span className='text-[#1D77FF] underline cursor-pointer' onClick={handleUseQrCode}>{i18n.t('扫码支付')}</span></div>
          <div className='flex justify-between'>
            <div>
              <span className='text-[#F54531] text-[14px] font-bold'>¥</span>
              <span className='text-[#F54531] text-[24px] font-bold mx-[2px]'>{amount}</span>
              <span className='text-[14px] font-bold'>{i18n.t('元')}</span>
            </div>
            <div>
              <div className='mt-[0px]'>{i18n.t('支付即代表你同意')}<a className='text-[#1D77FF] underline' target='_blank' href={externalLink.vipAgreement['zh-CN']} rel="noreferrer">{i18n.t('会员协议')}</a></div>
            </div>
          </div>
          <div className='grid grid-cols-2 gap-[10px] py-[10px]' style={
            currentOrderStatus === 2 ? {pointerEvents: 'none', opacity: 0.5} : {pointerEvents: 'auto', opacity: 1}
          }>
            <PayButton orderNumber={openQrCode ? '' : orderNumber || ''} type={1} />
            <PayButton orderNumber={openQrCode ? '' : orderNumber || ''} type={2} />
          </div>
        </div>

      </div>
    }

  </Drawer>;
};
